var map = {
	"./1.png": "c1c5",
	"./2.jpg": "593c",
	"./2.png": "81e5",
	"./3.mp4": "cfae",
	"./3.png": "619a",
	"./IDC.jpg": "e54f",
	"./about-us.jpg": "98e2",
	"./about_chanyeyuan.jpg": "3fd2",
	"./about_chanyeyuan.png": "c25f",
	"./about_jianjie.jpg": "fc32",
	"./about_shengtai.jpg": "f640",
	"./about_shengtaita.jpg": "cc40",
	"./about_yuanjing.jpg": "f78d",
	"./bg_IDC.png": "ebc4",
	"./bg_about.png": "e191",
	"./bg_contact.png": "834a",
	"./bg_dashujv.png": "d01f",
	"./bg_news.png": "197d",
	"./bg_product.png": "dfdf",
	"./bg_yunwei.png": "5577",
	"./chanyeyuan.jpg": "656f",
	"./chanyeyuan2.png": "718d",
	"./chanyeyuan3.png": "f2fa",
	"./chanyeyuan4.png": "cc59",
	"./chanyeyuan5.png": "fe89",
	"./cloud.png": "9c9c",
	"./down-arrow.png": "ab9f",
	"./foot.png": "074b",
	"./foot_img.png": "18df",
	"./fwys1.png": "5b76",
	"./fwys2.png": "e2d7",
	"./fwys3.png": "fd60",
	"./fwys4.png": "3249",
	"./fzjh1.png": "1809",
	"./fzjh2.png": "ecd4",
	"./fzjh3.png": "8180",
	"./idc_area.png": "565e",
	"./idc_huoban.jpg": "1fda",
	"./idc_level.jpg": "b06b",
	"./idc_tiliang.jpg": "ea1c",
	"./logo.png": "9d64",
	"./logo_text.png": "4b7f",
	"./logotext.png": "b73a",
	"./lxwm1.png": "f3d6",
	"./lxwm2.png": "90ac",
	"./lxwm3.png": "0e41",
	"./lxwm4.png": "079f",
	"./news1.jpg": "286b",
	"./news2.jpg": "2162",
	"./news3.jpg": "173f",
	"./nrff1.png": "7ab0",
	"./nrff2.png": "18f8",
	"./nrff3.png": "4236",
	"./platform_sjck.jpg": "0b96",
	"./platform_sjfx.jpg": "f07c",
	"./platform_sjqx.png": "213c",
	"./product_icon1.png": "7072",
	"./product_icon2.png": "fcde",
	"./product_icon3.png": "caa1",
	"./product_icon4.png": "8a89",
	"./product_icon5.png": "40a1",
	"./product_icon6.png": "83ca",
	"./product_icon7.png": "0406",
	"./product_icon8.png": "847b",
	"./product_icon9.png": "c2cd",
	"./product_rjkf1.png": "524c",
	"./product_rjkf2.jpg": "4771",
	"./product_rjkf3.jpg": "b211",
	"./product_sjck.gif": "7df6",
	"./product_sjfx.jpg": "3d88",
	"./product_yzm1.png": "bb0c",
	"./product_yzm2.jpg": "8e66",
	"./product_yzm3.png": "1d08",
	"./products1.jpg": "7b32",
	"./products2.jpg": "5ad1",
	"./products3.jpg": "c40a",
	"./products4.jpg": "b7a5",
	"./video.jpg": "faed",
	"./ycc1.png": "5453",
	"./ycc2.png": "6cb6",
	"./ycc3.png": "92eb",
	"./yzm1.png": "40c4",
	"./yzm2.png": "8d63",
	"./yzm3.png": "20c0",
	"./yzm4.png": "b571",
	"./云产品云储存.jpg": "deb8",
	"./云产品云桌面.jpg": "0816",
	"./云产品内容分发.jpg": "7bcc0",
	"./云产品负载均衡.jpg": "cc16",
	"./云产品顶部.png": "8e4b",
	"./云服务云开发.jpg": "01d1",
	"./云服务云课堂.jpg": "aba3",
	"./人工智能.jpg": "74fe",
	"./企业.png": "3245",
	"./企业2.png": "32f5",
	"./企业3.png": "016b",
	"./企业4.png": "c6de",
	"./在线教育5.png": "0e45",
	"./在线教育6.png": "56f5",
	"./大数据平台数据仓库.jpg": "0b33",
	"./大数据平台数据分析2.jpg": "82c8",
	"./大数据平台数据清洗.jpg": "720d",
	"./广告投放.jpg": "152e",
	"./政务.png": "fa59",
	"./政务2.png": "002d",
	"./政务3.png": "88d6",
	"./政务4.png": "850c",
	"./教育.png": "0836",
	"./教育2.png": "7e19",
	"./教育3.png": "fb82",
	"./教育4.png": "f411",
	"./数字经济产业园数字资源应用1.png": "5285",
	"./数字经济产业园数字资源应用2.png": "3b14",
	"./数字经济产业园数字资源应用3.png": "f6d4",
	"./数字经济产业园顶部.png": "80d6",
	"./数据中心特色.png": "9869",
	"./数据分析.jpg": "ce4a",
	"./数据挖掘.jpg": "9737",
	"./数据运营.jpg": "a8b5",
	"./无人驾驶.jpg": "4220",
	"./机器学习.jpg": "27aa",
	"./生态基地.gif": "5ab7",
	"./生态基地.png": "faff",
	"./生态基地2.png": "ba91",
	"./生态基地3.jpg": "8462",
	"./生态基地4.png": "9073",
	"./生态基地5.png": "5c79",
	"./生态基地6.png": "d513",
	"./生态基地7.png": "e2a0",
	"./生态基地顶部.png": "7b31",
	"./软件服务企业办公.jpg": "0a44",
	"./软件服务企业办公1.jpg": "9333",
	"./软件服务智慧政务1.png": "0e16",
	"./软件服务智慧政务2.png": "d8ad",
	"./软件服务智慧政务3.png": "ac2f",
	"./软件服务智慧教育1.jpg": "99a8",
	"./软件服务智慧教育2.jpg": "2fbd",
	"./软件服务规划咨询.png": "2492",
	"./风险控制.jpg": "6d6b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";